import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ReportsService } from '../../services/reports.service';
import { AuthService } from '../../modules/authentication/services/auth.service';
import { ICellRendererParams } from 'ag-grid-community';
import { Location } from '@angular/common';
import { parseTokens } from '../../helpers/token-parser';

@Component({
  selector: 'redirect-and-switch-company-via-report',
  template: `
    <span>
      <button
        mat-button
        fxFlex
        class="grid-link-button grid-text"
        [innerHtml]="value"
        (click)="triggerAction()"
      ></button>
    </span>
  `,
  styles: [],
})
export class RedirectAndSwitchCompanyButtonComponent implements ICellRendererAngularComp {
  public value: string;
  private redirect: string | null;
  private company: string;

  constructor(private location: Location, private rptService: ReportsService, private authService: AuthService) {}

  public agInit(params: ICellRendererParams) {
    const config = this.rptService.getRendererConfigFor(params.colDef.colId);

    this.value = params.value;
    this.redirect = parseTokens(config.redirect, params.data);
    this.company = parseTokens(config.company, params.data);
  }

  public triggerAction() {
    this.authService.switchToSelectedCompany(this.company, this.redirect);
  }

  public refresh(): boolean {
    return false;
  }
}
